import {
  BaseService,
  Status,
  MessageResponse,
  MessageData,
} from './base.service';

class ContactService extends BaseService {
  private url: string = '/api/contact';

  constructor() {
    super();
  }

  public async delete(id: number): Promise<MessageResponse> {
    const res = await this.$http.delete<MessageData>(`${this.url}/${id}`);

    return {
      status: res.status === Status.Ok,
      message: res.data.message,
    };
  }
}

export default new ContactService();
